/**
 * Kendo Grid Component 전용 함수 모듈.
 *
 *
 */
const convertKendoFilterToEtnersFilterOption = function(options, operation) {
  if(operation === 'read') {
    let customEtnersFilters;

    if(options.filter != undefined) {
      let kendoFilters = options.filter.filters;

      customEtnersFilters = new Array()

      if(options.filter.filters.length == 1) {
        let kendoFilters = options.filter.filters[0];

        customEtnersFilters.push({
          logic: "single",
          filters : [
            {
              field : kendoFilters.field,
              operator: kendoFilters.operator,
              value: kendoFilters.value
            }
          ]
        })
      } else if(options.filter.filters.length > 1 && options.filter.filters[0].filters != undefined) {

        for(let i=0 ; i < options.filter.filters.length; i++) {
          let kendoFilters2 = options.filter.filters[i]

          if(kendoFilters2.filters == undefined) {
            customEtnersFilters.push({
              logic: "single",
              filters : [
                {
                  field : kendoFilters2.field,
                  operator: kendoFilters2.operator,
                  value: kendoFilters2.value
                }
              ]
            })
          } else {
            customEtnersFilters.push({
              logic: options.filter.filters[i].logic,
              filters : [
                {
                  field : kendoFilters2.filters[0].field,
                  operator: kendoFilters2.filters[0].operator,
                  value: kendoFilters2.filters[0].value
                },
                {
                  field : kendoFilters2.filters[1].field,
                  operator: kendoFilters2.filters[1].operator,
                  value: kendoFilters2.filters[1].value
                }
              ]
            })
          }

        }
      } else if (options.filter.logic != undefined && options.filter.filters.length > 1) {
        let newFiltersArray = new Array()

        for(let i=0; i < options.filter.filters.length; i++) {
          let filter = options.filter.filters[i]

          newFiltersArray.push({
            field : filter.field,
            operator : filter.operator,
            value : filter.value
          })
        }

        customEtnersFilters.push({
          logic: options.filter.logic,
          filters : newFiltersArray
        })
      } else {
        throw new Error("이윤성 대리에게 문의해주세요.")
      }

    }

    return customEtnersFilters;
  }

}

const generateFilterOption = function(generateOption) {
  if(generateOption.logic == undefined) {
    generateOption.logic = 'and'
  }

  if(generateOption.operator == undefined) {
    generateOption.operator = 'like'
  }

  if(generateOption.logic != 'and'
  && generateOption.logic != 'or'
  && generateOption.logic != 'between'
  && generateOption.logic != 'betweenOr'
  ) {
    throw new Error("logic은 오로지 and와 or, between, betweenOr 만 가능합니다.")
  }

  const supportOperators = [
    'between',
    'contains',
    'doesNotContain',
    'eq',
    'isequalsto',
    'ne',
    'isnotequalsto',
    'isnull',
    'isnotnull',
    'isempty',
    'isnotempty',
    'loe',
    'littleorequal',
    'lt',
    'little',
    'goe',
    'greaterorequal',
    'gt',
    'greater',
    'like',
    'notlike'
  ]

  let allowOperatorFl = false
  let supportOperatorsString = "";

  for(let i=0; i < supportOperators.length; i++) {
    let operator = supportOperators[i];

    if(generateOption.operator == operator) {
        allowOperatorFl = true
    }

    if(i > 0) {
      supportOperatorsString += ", "
    }

    supportOperatorsString += operator
  }

  if(!allowOperatorFl) {
    throw new Error(`operator는 현재 ${supportOperatorsString}를 지원합니다. ${generateOption.operator} 옵션은 존재하지 않습니다.`)
  }

  if(generateOption.columnName == undefined) {
    throw new Error("columnName은 반드시 존재해야 합니다.")
  }

  if(generateOption.value == undefined) {
    throw new Error("value값은 반드시 1개 이상 존재해야 합니다.")
    //2개를 보낼 때는 Array로 추가해주세요.
  }



  if(generateOption.value instanceof Array && generateOption.logic == 'between') {
    return  {
              'logic' : generateOption.logic,
              'filters' : [
                {
                  'operator' : 'and', //between일 때는 그냥 and로 처리.
                  'field' : generateOption.columnName,
                  'value' : generateOption.value[0]
                },
                {
                  'operator' : 'and', //between일 때는 그냥 and로 처리.
                  'field' : generateOption.columnName,
                  'value' : generateOption.value[1]
                }
              ]
            }
  } else if(generateOption.value instanceof Array && generateOption.logic === 'betweenOr'){
        return  {
              'logic' : generateOption.logic,
              'filters' : [
                {
                  'operator' : generateOption.operator,
                  'field' : generateOption.columnName[0],
                  'value' : generateOption.value[0]
                },
                {
                  'operator' : generateOption.operator,
                  'field' : generateOption.columnName[1],
                  'value' : generateOption.value[1]
                }
              ]
            }
  }
  else if(generateOption.value != undefined) {
    return  {
              'logic' : generateOption.logic,
              'filters' : [
                {
                  'operator' : generateOption.operator, //like or contains..자세한 건 supportOperators 참조.
                  'field' : generateOption.columnName,
                  'value' : generateOption.value
                }
              ]
            }
  }

}

export default {
  convertKendoFilterToEtnersFilterOption,
  generateFilterOption
}
